{
  "version": 1,
  "asset_id": "8e0eaa81-5c52-4113-9a09-6300f5178d17",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8e0eaa81-5c52-4113-9a09-6300f5178d17/sleeve-to-bypass-dissection-976.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8e0eaa81-5c52-4113-9a09-6300f5178d17/sleeve-to-bypass-dissection-976.webp",
  "original_filename": "sleeve-to-bypass-dissection-976.webp",
  "size": 55844,
  "content_type": "image/webp",
  "created_at": "2026-10-05T18:59:33Z"
}
